import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const LoginIconNew = (props) => (
  <SvgIcon {...props}>
<g>
	<path fill={props.color} d="M18.745,20H9c-0.274,0-0.527-0.15-0.658-0.391l-2.626-4.814c-0.198-0.364-0.064-0.819,0.299-1.018
		c0.365-0.199,0.819-0.064,1.018,0.299L9.445,18.5H18.3l4.096-7.5L18.3,3.5H9.445L7.032,7.923C6.834,8.287,6.379,8.421,6.015,8.223
		C5.651,8.024,5.517,7.569,5.715,7.205l2.626-4.814C8.473,2.15,8.726,2,9,2h9.745c0.274,0,0.527,0.15,0.658,0.39l4.505,8.25
		c0.123,0.224,0.123,0.495,0,0.719l-4.505,8.25C19.272,19.85,19.019,20,18.745,20z"/>
</g>
<g>
	<g>
		<g>
			<path fill={props.color} d="M12.375,16.25c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.293-0.293-0.768,0-1.061l3.97-3.97l-3.97-3.97
				c-0.293-0.293-0.293-0.768,0-1.061s0.768-0.293,1.061,0l4.5,4.5c0.293,0.293,0.293,0.768,0,1.061l-4.5,4.5
				C12.759,16.177,12.567,16.25,12.375,16.25z"/>
		</g>
	</g>
</g>
<g>
	<path fill={props.color} d="M16.875,11.75H0.75C0.336,11.75,0,11.414,0,11s0.336-0.75,0.75-0.75h16.125c0.414,0,0.75,0.336,0.75,0.75
		S17.289,11.75,16.875,11.75z"/>
</g>
  </SvgIcon>
);

export default LoginIconNew;



// WEBPACK FOOTER //
// ./src/icons/menu/LoginIconNew.jsx